import { Component } from '@angular/core';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent {

  slides =[
    {id:1, title:'Georgia Pacific', img:'./assets/imgs/client-logo/gp.png'},
    {id:2, title:'Macmillan', img:'./assets/imgs/client-logo/macmillan.png'},
    {id:3, title:'Stanley', img:'./assets/imgs/client-logo/stanley.png'},
    {id:4, title:'Realpage', img:'./assets/imgs/client-logo/rp.png'},
    {id:5, title:'Unilever', img:'./assets/imgs/client-logo/Unilever.png'},
    {id:6, title:'Worldbank', img:'./assets/imgs/client-logo/worldbank.png'},
  ]
}
